import React, { Fragment, useContext, useEffect, useState } from 'react';
import ErrorBoundary from '../ErrorBoundary';
import { connect } from 'react-redux';
import { Badge, Button, Dropdown, Modal, Table } from 'react-bootstrap';
import Editor from '@jsx/components/RichTextEditor';
import { AdminActions } from '@adapters/redux/reducer/admin';
import PageLoader from '../Loader/PageLoader';
import { ToastNotificationContext } from '@context/ToastNotificationContext';
import swal from 'sweetalert';
import Swal from 'sweetalert2';
import { fullBackendPath } from 'core/helpers';
import { ICON_MORE } from '@services/constant';

const Page = (props) => {
  const { notifySuccess, notifyError } = useContext(ToastNotificationContext);
  const { comments, updateData, deleteData, updating } = props;

  const [showModal, setShowModal] = useState(false);
  const [showModalDetail, setShowModalDetail] = useState(false);

  const [modalType, setModalType] = useState('create');
  const [itemUpdate, setItemUpdate] = useState();
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [comment, setComment] = useState('');
  const [star, setStar] = useState(5);
  const [avatar, setAvatar] = useState(null);

  useEffect(() => {
    if (!showModal) {
      setItemUpdate(null);
      setFirstName('');
      setLastName('');
      setComment('');
      setStar(5);
      setAvatar(null);
    }
  }, [showModal]);

  const onClickShowModalCreate = () => {
    setModalType('create');
    setFirstName('');
    setLastName('');
    setComment('');
    setAvatar(null);
    setStar(5);
    setShowModal(true);
  };

  const onClickShowModalEdit = (item) => {
    const { first_name, last_name, comment, star } = item;

    setModalType('edit');
    setItemUpdate(item);
    setFirstName(first_name);
    setLastName(last_name);
    setComment(comment);
    setAvatar(null);
    setStar(star);
    setShowModal(true);
  };

  const onClickDelete = (item) => {
    Swal.fire({
      title: 'Are you sure?',
      text: 'Once deleted, you will not be able to recover this!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      confirmButtonColor: 'red',
      position: 'top',
      customClass: 'margin-top-20',
      reverseButtons: true,
    }).then(({ value }) => {
      if (value) {
        deleteData(
          item.id,
          `comment/${item.id}`,
          'comments',
          (isError, error) => {
            if (isError) {
              notifyError(error);
            } else {
              notifySuccess('Delete successfully');
            }
          }
        );
      }
    });
  };

  const onSubmit = () => {
    const method = modalType === 'create' ? 'post' : 'put';
    const url = modalType === 'create' ? 'comment' : `comment/${itemUpdate.id}`;

    const params = {
      first_name: firstName,
      last_name: lastName,
      star,
      comment,
      images: [],
    };

    if (avatar)
      params.images.push({
        field: 'avatar',
        image: avatar,
      });

    updateData(method, url, params, 'comments', (isError, error) => {
      if (isError) {
        notifyError(error);
      } else {
        setShowModal(false);
        notifySuccess(
          method === 'post' ? 'Create successfully' : 'Update successfully'
        );
      }
    });
  };

  return (
    <Fragment>
      <div className="text-right mb-3">
        <button onClick={onClickShowModalCreate} className="btn btn-success">
          Create
        </button>
      </div>
      <div className="row">
        <div className="col-12">
          <div className="card">
            <div className="card-header">
              <h4 className="card-title">List comments</h4>
            </div>
            <div className="card-body position-relative">
              {updating && !showModal && <PageLoader />}
              <Table responsive>
                <thead>
                  <tr>
                    <th className="width80">
                      <strong>#</strong>
                    </th>
                    <th>
                      <strong>First Name</strong>
                    </th>
                    <th>
                      <strong>Last Name</strong>
                    </th>
                    <th>
                      <strong>Avatar</strong>
                    </th>
                    <th>
                      <strong>Comment</strong>
                    </th>
                    <th>
                      <strong>Star</strong>
                    </th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {comments?.map((comment, index) => {
                    return (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{comment.first_name}</td>
                        <td>{comment.last_name}</td>
                        <td>
                          {comment.avatar?.path && (
                            <img
                              width={'100%'}
                              height={200}
                              style={{ objectFit: 'contain' }}
                              src={fullBackendPath(comment.avatar.path)}
                            />
                          )}
                        </td>
                        <td>
                          <p
                            dangerouslySetInnerHTML={{
                              __html: comment.comment,
                            }}
                          ></p>
                        </td>
                        <td>{comment.star}</td>
                        <td>
                          <Dropdown>
                            <Dropdown.Toggle
                              variant="success"
                              className="light sharp i-false"
                            >
                              {ICON_MORE}
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                              <Dropdown.Item
                                onClick={() => onClickShowModalEdit(comment)}
                              >
                                Edit
                              </Dropdown.Item>
                              <Dropdown.Item
                                onClick={() => onClickDelete(comment)}
                              >
                                Delete
                              </Dropdown.Item>
                            </Dropdown.Menu>
                          </Dropdown>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
            </div>
          </div>
        </div>
      </div>
      <Modal className="fade" enforceFocus={false} show={showModal} size="lg">
        <form
          onSubmit={(e) => {
            e.preventDefault();
            onSubmit();
          }}
        >
          <Modal.Header>
            <Modal.Title>
              {modalType === 'create' ? 'Create' : 'Edit'}
            </Modal.Title>
            <Button
              variant=""
              className="btn-close"
              disabled={updating}
              onClick={() => setShowModal(false)}
            ></Button>
          </Modal.Header>
          <Modal.Body>
            {updating && <PageLoader />}
            <div className="form-group">
              <label className="form-label">First Name</label>
              <input
                className="form-control"
                type="text"
                id="first-name"
                value={firstName}
                onChange={(e) => setFirstName(e.target.value)}
              />
            </div>
            <div className="form-group mt-3">
              <label className="form-label">Last Name</label>
              <input
                className="form-control"
                type="text"
                id="last-name"
                value={lastName}
                onChange={(e) => setLastName(e.target.value)}
              />
            </div>
            <div className="form-group mt-3">
              <label className="form-label">Comment</label>
              <Editor value={comment} onChange={setComment} />
            </div>
            <div className="form-group mt-3">
              <label className="form-label">Star</label>
              <select
                value={`${star}`}
                className="form-control"
                id="star"
                onChange={(e) => setStar(e.target.value)}
              >
                <option value="1">1</option>
                <option value="2">2</option>
                <option value="3">3</option>
                <option value="4">4</option>
                <option value="5">5</option>
              </select>
            </div>
            <div className="form-group mt-3">
              <label className="form-label">Avatar</label>
              <input
                className="form-control"
                type="file"
                id="avatar"
                accept="image/png, image/jpeg"
                onChange={(e) => setAvatar(e.target.files[0])}
              />
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              disabled={updating}
              variant="danger light"
              onClick={() => setShowModal(false)}
            >
              Close
            </Button>
            <Button
              disabled={updating}
              variant=""
              type="submit"
              className="btn btn-primary"
            >
              {modalType === 'create' ? 'Create' : 'Update'}
            </Button>
          </Modal.Footer>
        </form>
      </Modal>
    </Fragment>
  );
};

const mapStateToProps = (state) => ({
  comments: state.admin.comments,
  updating: state.admin.updating,
});

const mapDispatchToProps = (dispatch) => ({
  updateData: (method, url, params, field, callback) =>
    dispatch(AdminActions.updateData(method, url, params, field, callback)),
  deleteData: (id, url, field, callback) =>
    dispatch(AdminActions.deleteData(id, url, field, callback)),
});

const withErrorBoundary = (props) => (
  <ErrorBoundary>
    <Page {...props} />
  </ErrorBoundary>
);

export default connect(mapStateToProps, mapDispatchToProps)(withErrorBoundary);
